const BADGE_TONE_CLASSES = {
  slate: 'inline-flex items-center gap-1.5 status-pill bg-secondary-100 text-secondary-800 ring-1 ring-inset ring-secondary-500/20',
  sky: 'inline-flex items-center gap-1.5 status-pill bg-sky-50 text-sky-900 ring-1 ring-inset ring-sky-600/20',
  violet: 'inline-flex items-center gap-1.5 status-pill bg-violet-50 text-violet-900 ring-1 ring-inset ring-violet-600/20',
  amber: 'inline-flex items-center gap-1.5 status-pill bg-amber-50 text-amber-900 ring-1 ring-inset ring-amber-600/20',
  emerald: 'inline-flex items-center gap-1.5 status-pill bg-emerald-50 text-emerald-900 ring-1 ring-inset ring-emerald-600/20',
  indigo: 'inline-flex items-center gap-1.5 status-pill bg-indigo-50 text-indigo-900 ring-1 ring-inset ring-indigo-600/20',
  rose: 'inline-flex items-center gap-1.5 status-pill bg-rose-50 text-rose-900 ring-1 ring-inset ring-rose-600/20',
  orange: 'inline-flex items-center gap-1.5 status-pill bg-orange-50 text-orange-900 ring-1 ring-inset ring-orange-600/20',
};

const TEXT_TONE_CLASSES = {
  slate: '!text-secondary-700 ',
  sky: '!text-sky-700 ',
  violet: '!text-violet-700 ',
  amber: '!text-amber-700 ',
  emerald: '!text-emerald-700 ',
  indigo: '!text-indigo-700 ',
  rose: '!text-rose-700 ',
  orange: '!text-orange-700 ',
};

const FALLBACK_STATUS_LABELS = {
  NEW: 'New',
  CALL: 'Call',
  VISIT: 'Visit',
  DEMO: 'Demo',
  SALE: 'Sale',
};

const FALLBACK_PARTNER_STATUS_LABELS = {
  NEW: 'New',
  CALL: 'Call',
  INTERVIEW: 'Interviewed',
  NOT_INTERESTED: 'Not interested',
};

export const PARTNER_STATUS_FALLBACK = [
  { code: 'NEW', label: 'New', badge_tone: 'slate', is_default: true },
  { code: 'CALL', label: 'Call', badge_tone: 'sky' },
  { code: 'INTERVIEW', label: 'Interviewed', badge_tone: 'violet' },
  { code: 'NOT_INTERESTED', label: 'Not interested', badge_tone: 'rose' },
];

export const PARTNER_PROSPECT_STATUSES = ['NEW', 'CALL', 'INTERVIEW', 'NOT_INTERESTED'];

export function isPartnerProspect(prospect) {
  const type = String(prospect?.prospect_type || prospect?.type || 'client').toLowerCase();
  return type === 'partner';
}

export function resolveProspectStatuses(prospectType, prospectStatuses, partnerStatuses) {
  if (String(prospectType || '').toLowerCase() === 'partner') {
    return partnerStatuses?.length ? partnerStatuses : PARTNER_STATUS_FALLBACK;
  }
  return prospectStatuses || [];
}

export const BADGE_TONE_OPTIONS = Object.keys(BADGE_TONE_CLASSES);

export function prospectStatusLabel(status, t, prospectStatuses) {
  const key = String(status || '').trim().toUpperCase();
  // Always follow the active UI language for known statuses to avoid mixing
  // languages. Config labels only apply to custom/unknown codes.
  if (t?.vendor?.prospects?.statuses?.[key]) {
    return t.vendor.prospects.statuses[key];
  }
  const fromConfig = prospectStatuses?.find(
    (s) => String(s.code || '').trim().toUpperCase() === key
  );
  if (fromConfig?.label) return fromConfig.label;
  return FALLBACK_STATUS_LABELS[key] || FALLBACK_PARTNER_STATUS_LABELS[key] || status;
}

function prospectStatusTone(status, prospectStatuses) {
  const key = String(status || '').trim().toUpperCase();
  const fromConfig = prospectStatuses?.find(
    (s) => String(s.code || '').trim().toUpperCase() === key
  );
  if (fromConfig?.badge_tone && BADGE_TONE_CLASSES[fromConfig.badge_tone]) {
    return fromConfig.badge_tone;
  }
  return 'slate';
}

export function prospectStatusBadgeClass(status, prospectStatuses) {
  const tone = prospectStatusTone(status, prospectStatuses);
  return BADGE_TONE_CLASSES[tone];
}

export function prospectStatusTextClass(status, prospectStatuses) {
  const tone = prospectStatusTone(status, prospectStatuses);
  return TEXT_TONE_CLASSES[tone];
}

export const PROSPECT_STATUSES = ['NEW', 'CALL', 'VISIT', 'DEMO', 'SALE'];
